<template>
  <v-text-field
    :label
    v-model="inputModel"
    :rules
    :class="[props.class, { 'text-purple': isDirty, dirty: isDirty }]"
    :style
    :variant
    :density
    :type="isTypeNumber ? 'number' : 'text'"
    @click:clear="clearValue"
    @input="updateValue($event.target.value)"
  >
  </v-text-field>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: null
  },
  variant: {
    type: String,
    default: null
  },
  density: {
    type: String,
    default: null
  },
  class: {
    type: String,
    default: null
  },
  style: {
    type: Object,
    default: null
  },
  rules: {
    type: Array,
    default() {
      return undefined
    }
  },
  isTypeNumber: {
    type: Boolean,
    default: false
  }
})

const originalValue = ref()

const inputModel = defineModel()
const emit = defineEmits(['inputUpdated'])

const isDirty = computed(() => {
  //console.log('>> DirtyTextField typeof(org, input):', typeof originalValue.value, typeof inputModel.value)
  if (typeof originalValue.value == 'number' || typeof inputModel.value == 'number' || props.isTypeNumber) {
    return parseInt(inputModel.value || 0) != parseInt(originalValue.value || 0)
  }
  //return inputModel.value !== '' && inputModel.value !== originalValue.value
  return inputModel.value !== originalValue.value
})

onMounted(() => {
  //console.warn('>> DirtyTextField onMounted << - originalValue', inputModel.value)
  originalValue.value = inputModel.value
})

const updateValue = (changedValue) => {
  nextTick(() => {
    emit('inputUpdated', isDirty.value)
  })
}
const clearValue = () => {
  inputModel.value = ''
}
</script>

<style lang="scss" scoped></style>
